import { render, staticRenderFns } from "./AgendaSingleMain.vue?vue&type=template&id=65ea76e9&"
import script from "./AgendaSingleMain.vue?vue&type=script&lang=js&"
export * from "./AgendaSingleMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports